var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { pageImages } from '@/pages/images';
import { StepLayout } from './step-layout.component';
import { LogoAndHeading } from './logo-and-heading.component';
import { ChevronIcon } from './chevron-icon.component';
import { InformationToggle } from './information-toggle.component';
import { Typography, useTheme } from '@mui/material';
import { useState } from 'react';
import { AgeSelect } from 'hx-ui';
import { useFormContext } from 'react-hook-form';
import { palette } from '@/theme/palette';
import { useSendButtonClick } from '@/hooks/use-send-button-click.hook';
export function AgeSelectComponent() {
    var theme = useTheme();
    var _a = useState(false), isOpen = _a[0], setIsOpen = _a[1];
    var getValues = useFormContext().getValues;
    var handleOpen = function () { return setIsOpen(true); };
    var handleClose = function () { return setIsOpen(false); };
    var birthYearValue = getValues('birth-year');
    var handleSendButtonClick = useSendButtonClick().handleSendButtonClick;
    return (_jsx(StepLayout, { image: pageImages.familySmiling, progress: {
            step: 1,
            phase: 0,
        }, heading: _jsx(LogoAndHeading, { headingText: 'Select your date of birth.', className: "text-lg md:text-2xl", image: {
                height: 110,
                width: 118,
            } }), content: _jsx("div", __assign({ className: "py-5" }, { children: _jsx(AgeSelect, { selectProps: {
                    variant: 'standard',
                    className: 'min-w-[15em]',
                    showEighteenPlusYearsOnly: true,
                    sx: {
                        color: palette.text.dark,
                        fontWeight: 700,
                        fontSize: !!birthYearValue ? '32px' : 'inherit',
                        '&.MuiInput-underline:before': {
                            borderColor: palette.primary.main,
                        },
                        '& .MuiInputBase-root': {
                            backgroundColor: 'transparent !important',
                            '&.Mui-focused': {
                                backgroundColor: 'transparent',
                            },
                        },
                        '& .MuiSelect-select': {
                            backgroundColor: 'transparent !important',
                        },
                    },
                    customIcon: function (props) { return _jsx(ChevronIcon, __assign({}, props, { isOpen: isOpen })); },
                    handleOpen: handleOpen,
                    handleClose: handleClose,
                } }) })), info: _jsx(InformationToggle, __assign({ title: "Why ask my age?", chevronColor: theme.palette.primary.main, onClick: function () { return handleSendButtonClick('why_ask_my_age'); } }, { children: _jsx(Typography, __assign({ className: 'text-xs md:text-base' }, { children: "Hearing loss levels vary by age, having this information adds critical context for the accuracy of your hearing assessment results." })) })) }));
}
